import { createRouter, createWebHistory } from 'vue-router'
import archives from '@/views/archives';
import history from '@/views/history';
import champions from '@/views/champions';
import story from '@/views/story';
const routes = [
  {
    path: '/60th/',
    component: history,
    meta: { title: 'MFJ 60年の歩み', desc: 'ディスクリプションを記述' , en: 'History of MFJ' }
  },
  {
    path: '/60th/story',
    component: story,
    meta: { title: 'モーターサイクルスポーツの歴史', desc: 'ディスクリプションを記述' , en: 'Story of History' }
  },
  {
    path: '/60th/champions',
    component: champions,
    meta: { title: '歴代チャンピオン', desc: 'ディスクリプションを記述' , en: 'Champions' }
  },
  {
    path: '/60th/archives',
    component: archives,
    meta: { title: 'MFJライディング', desc: 'ディスクリプションを記述' , en: 'Archive Search' }
  },
]

const scrollBehavior = () => {
  window.scrollTo({
      top: 0
  });
};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior
})



export default router
